export default function Game_Canvas() {
  return (
    <div>
      <h1>Game_Canvas Component</h1>
    </div>
  );
}
